'use client';

import { useEffect } from 'react';
import { ROUTES } from 'constant';
import { useRouter } from 'next/navigation';

import { Box } from '@chakra-ui/react';

import { useAppSelector } from 'store/hooks';

import {
  buildLoginUrlWithReturnPath,
  rememberCurrentPageForPostAuthLogin
} from 'utils';

const Home = () => {
  const router = useRouter();
  const { userInfo } = useAppSelector((state) => state.persistAuth);
  const { user, isLoading } = useAppSelector((state) => state.user);

  useEffect(() => {
    const hasCredentials = Boolean(userInfo?.token) && Boolean(userInfo?.clid);

    if (hasCredentials) {
      if (user || isLoading) {
        router.replace(ROUTES.dashboard);
      }
      return;
    }

    if (isLoading) {
      return;
    }

    const returnPath = `${window.location.pathname}${window.location.search}`;
    rememberCurrentPageForPostAuthLogin();
    router.replace(buildLoginUrlWithReturnPath(ROUTES.login, returnPath));
  }, [router, userInfo, user, isLoading]);

  return <Box />;
};

export default Home;
